export const mediaQueries = {
  lgTablet: '(max-width: 1024px)',
  smlTablet: '(max-width: 768px)',
  lgPhone: '(max-width: 530px)',
  smlPhone: '(max-width: 400px)'
};

// $breakpoint-desktop-lg: 1600px;
// $breakpoint-desktop-sml: 1200px;
// $breakpoint-tablet-lg: 1024px;
// $breakpoint-tablet-sml: 768px;
// $breakpoint-phone-lg: 530px;
// $breakpoint-phone-sml: 400px;
